import { HttpClient } from '@angular/common/http';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import {
  computed,
  inject,
  InjectionToken,
  PLATFORM_ID,
  signal,
  Signal,
  WritableSignal,
} from '@angular/core';
import { environment } from '@environments/environment';
import { ShopData } from '@informally/common/shop-data/shop-data.interface';
import { lastValueFrom } from 'rxjs';

export const ACTIVE_SHOP_DOMAIN = new InjectionToken<WritableSignal<string>>('ACTIVE_SHOP_DOMAIN', {
  factory: () => {
    const platformId = inject(PLATFORM_ID);
    const documentRef = inject(DOCUMENT, { optional: true });

    if (environment.useDevSubdomain) {
      return signal(
        `${environment.useDevSubdomain}.${
          environment.shopDomainSuffix || environment.publicDomain
        }`,
      );
    }

    if (isPlatformBrowser(platformId)) {
      return signal(window.location.hostname);
    }

    const ssrDocumentHost = documentRef?.location?.hostname;
    if (ssrDocumentHost) {
      return signal(ssrDocumentHost);
    }

    return signal(environment.publicDomain || 'localhost');
  },
});

export const ACTIVE_SHOP_DATA = new InjectionToken<Signal<Promise<ShopData>>>('ACTIVE_SHOP_DATA', {
  factory: () => {
    const domain = inject(ACTIVE_SHOP_DOMAIN);
    const http = inject(HttpClient);

    return computed(() =>
      lastValueFrom(http.get<ShopData>(`${environment.dataServiceApi}shop-data/${domain()}`)),
    );
  },
});
